import { getRequest } from 'utils/http';
import { OpenAPI } from 'common/api';
import { Environment } from 'global/environment';

export function getPdf(referral: {
  id?: string;
  firstName: string;
  lastName: string;
  isExternalReferral?: boolean;
}) {
  const source = referral.isExternalReferral ? '?source=external' : '';
  const url = `${Environment.BACKEND_API}/referral/currentuser/${referral?.id}/pdf${source}`;
  return getRequest(url, {
    options: {
      headers: {
        Authorization: `Bearer ${OpenAPI.TOKEN}`,
      },
      responseType: 'blob',
    },
  });
}
